import axiosInst from "api/config/axiosConfig";

export interface CertificateRefreshStatus {
  serialNumber: string;
  softwareVersion: string;
  supported: boolean;
  online: boolean;
  reason?: string;
  reportedAt: number;
  report?: {
    certificate: { serial: string; sha256: string; notAfter: string };
    revocation: { status: string; checkedAt: number; reason?: string };
  };
  request?: {
    requestId: string;
    state: "queued" | "running" | "succeeded" | "failed" | "unconfirmed";
    requestedAt: number;
    reason?: string;
  };
}

const endpoint = "/beta/appSystemInfo";
const params = { manage: "certificateRefresh" };

export async function getCertificateRefreshStatus(serialNumber: string, signal?: AbortSignal) {
  const response = await axiosInst.get<CertificateRefreshStatus>(endpoint, {
    params: { ...params, serialNumber },
    timeout: 15000,
    signal,
  });
  return response.data;
}

export async function requestCertificateRefresh(serialNumber: string, requestId: string, signal?: AbortSignal) {
  const response = await axiosInst.post<CertificateRefreshStatus>(
    endpoint,
    { serialNumber, requestId },
    { params, signal, timeout: 20000 },
  );
  return response.data;
}

// Keep the same ID after an ambiguous POST failure so a retry cannot queue twice.
export function newCertificateRefreshRequestId(): string {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] % 16) + 64;
  bytes[8] = (bytes[8] % 64) + 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
